export default __webpack_public_path__ + "static/media/carone.f5e1196a.webp";